var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import DefaultParserModule from "./DefaultParserModule";
// Modules
import NormalComplementorModule from "./Modules/NormalComplementorModule";
import IndexComplementorModule from "./Modules/IndexComplementorModule";
import EmbeddedBufferModule from "./Modules/EmbeddedBufferModule";
export default class GLTFParser {
    constructor(gl, url) {
        this.gl = gl;
        this.url = url;
        this.parserModuleInstances = [];
        for (let i = 0; i < GLTFParser.parserModules.length; i++) {
            const moduleCtor = GLTFParser.parserModules[i];
            this.parserModuleInstances.push(new moduleCtor(this, url.substr(0, url.lastIndexOf("/") + 1)));
        }
    }
    callParserModule(target, arg) {
        for (let i = 0; i < this.parserModuleInstances.length; i++) {
            const module = this.parserModuleInstances[i];
            const moduleMethod = target(module);
            if (moduleMethod === void 0) {
                continue;
            }
            const result = moduleMethod.call(module, arg);
            if (result !== void 0) {
                return result;
            }
        }
        throw new Error(`Parsing gltf failed. At the module "${target.toString()}"`);
    }
    parse() {
        return __awaiter(this, void 0, void 0, function* () {
            const result = {};
            const gltfRaw = yield this.callParserModule(t => t.fetchGLTF, this.url);
            const gltf = this.callParserModule(t => t.loadAsGLTF, gltfRaw);
            result.tf = gltf;
            const textureResourcePromise = yield this.callParserModule(t => t.loadTextureResources, gltf).then(textures => {
                return this.callParserModule(t => t.loadMaterials, { tf: gltf, textures: textures });
            }).then(materials => {
                result.materials = materials;
            });
            const bufferResources = yield this.callParserModule(t => t.loadBufferResources, gltf)
                .then(buffers => {
                const bufferViews = this.callParserModule(t => t.loadBufferViews, { tf: gltf, buffers: buffers });
                const primitives = this.callParserModule(t => t.loadPrimitivesOfMesh, { tf: gltf, bufferViews: bufferViews });
                const animations = this.callParserModule(t => t.loadAnimations, { tf: gltf, bufferViews: bufferViews });
                result.primitives = primitives;
                result.bufferViews = bufferViews;
                result.animations = animations;
            });
            return result;
        });
    }
    static parseFromURL(gl, url) {
        return __awaiter(this, void 0, void 0, function* () {
            const parser = new GLTFParser(gl, url);
            return parser.parse();
        });
    }
}
GLTFParser.parserModules = [
    EmbeddedBufferModule,
    IndexComplementorModule,
    NormalComplementorModule,
    DefaultParserModule
];



// WEBPACK FOOTER //
// ./src/Parser/Parser.ts